import { useCallback } from "react";
import useComplianceView from "./useComplianceView";

export default function useComplianceSummaryGrid() {
  const { setViewData, grid } = useComplianceView();

  const onRowClick = (activeRow) =>
    setViewData({ grid: { ...grid, activeRow } });

  const onRefresh = useCallback(() => {
    setViewData({
      gridLoading: true,
      grid: {
        activeRow: null,
        data: [],
        headerDef: [],
        rowDef: [],
        span: [],
      },
      graph: {
        lines: [],
      },
    });
  }, [setViewData]);

  return {
    activeRow: grid.activeRow,
    grid,
    onRefresh,
    onRowClick,
  };
}
